<template>
    <div id="ModalDetalleError" class="modal" tabindex="-1" role="dialog">
        <div class="modal-dialog modal-lg" role="document">
            <div class="modal-content">

                <div class="modal-header">
                    <h5 class="modal-title">
                        Detalle del error
                    </h5>
                    <button type="button" class="close" @click="hide">
                        <span>&times;</span>
                    </button>
                </div>


                <div class="modal-body">
                    <div class="d-flex justify-content-between mb-2">
                        <div>
                            Transacción Kubber:
                        </div>
                        <div>
                            {{ factura?.uniqueid }}
                        </div>
                    </div>
                    <pre class="bg-light border rounded p-3 mb-0" style="white-space:pre-wrap;">{{ mensaje }}</pre>
                </div>

                <div class="modal-footer">
                    <button class="btn btn-primary" @click="reprocesar">
                        <i class="fa-solid fa-arrows-rotate"></i>
                        Borrar mensaje y reenviar
                    </button>

                    <button class="btn btn-secondary" @click="hide">
                        Cerrar
                    </button>
                </div>

            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            factura: null,
            boton: null,
            mensaje: ""
        };
    },

    methods: {
        show(factura, boton, mensaje) {
            this.factura = factura;
            this.boton = boton;
            this.mensaje = mensaje;
            $("#ModalDetalleError").modal("show");
        },

        hide() {
            $("#ModalDetalleError")
                .one("hidden.bs.modal", () => this.boton?.focus())
                .modal("hide");
        },


        reprocesar() {
            $("#ModalDetalleError").modal("hide");
            this.$emit("reprocesar", this.factura, this.boton);
        }
    }
};
</script>